//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        error: {
            type: [String, null],
            required: false,
            default: null,
        },

        value: {
            type: String,
            required: false,
            default: null,
        },
    },

    setup(props, ctx) {
        const { $store } = useNuxtApp();

        const privateUniversitiesExist = computed(() => {
            const universities = $store.getters['global/universities/getPartnerUniversities'];
            return universities.some((i) => i.is_private_institution);
        });

      const tvetUniversitiesExist = computed(() => {
        const universities = $store.getters['global/universities/getPartnerUniversities'];
        return universities.some((i) => i.is_tvet_institution);
      });


      let scopes = ['all', 'public'];

      if(privateUniversitiesExist.value){
        scopes.push('private');
      }

      if(tvetUniversitiesExist.value){
        scopes.push('tvet');
      }

      const selectedScope = ref(props.value || scopes[0]);

        watch(selectedScope, () => ctx.emit('input', selectedScope.value), { immediate: true });

        $store.dispatch('global/universities/fetchPartnerUniversities');

        return {
            privateUniversitiesExist,
            tvetUniversitiesExist,
            selectedScope,
            scopes,
        };
    },
};
